<template>
  <v-tooltip top v-if="text && text.length > 30">
    <template v-slot:activator="{ on, attrs }">
        <span
            v-bind="attrs"
            v-on="on"
            @click="copyText(text)"
            class="shot-text-value"
        >{{text.slice(0, 30)}}...</span>
    </template>
    <span v-if="copied" class="copied-message">Full text is copied to clipboard</span>
    <span v-else>{{text}}</span>
  </v-tooltip>
  <span v-else>{{text}}</span>
</template>

<script>
export default {
  name: 'ShortText',
  props: {
    text: {
      type: String,
      default: ''
    },
    noCopy: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    copied: false
  }),
  methods: {
    async copyText(text) {
      if(this.noCopy) return;
      await navigator.clipboard.writeText(text);
      this.copied = true;
      setTimeout(() => this.copied = false, 1000)
    }
  }
}
</script>

<style scoped lang="sass">
  .shot-text-value
    cursor: pointer
  .copied-message
    color: #2ED47A
    font-weight: bold
</style>
